<i18n>
{
    "fa": {
        "hour": "ساعت",
        "minute": "دقیقه",
        "second": "ثانیه",
        "untilEnd": "تا اتمام این پیشنهاد",
        "departingHour": "ساعت خروج",
        "arrivingHour": "ساعت ورود",
        "purchaseTicket": "خرید بلیط"
    }
}
</i18n>

<template>
    <div class="promotion-banner promotion-banner--timer">
        <div class="promotion-banner__side text-center w-500 text-darker">
            <div class="promotion-banner__badge my-2 text-nowrap">
                {{ $t('common.specialOffer') }}
            </div>

            <div class="mt-1">
                <count-down class="text-danger" :timer="banner.expiresOn" />
                <div class="text-darker small text-nowrap">
                    {{ $t('second') }}
                    {{ $t('minute') }}&nbsp;
                    {{ $t('hour') }}
                </div>
                <p class="m-0">
                    {{ $t('untilEnd') }}
                </p>
            </div>
        </div>
        <div class="promotion-banner__content flex flex-align-center">
            <div class="flex-1 flex py-2 px-1 flex-fill flex-align-center">
                <div>
                    <div class="w-500 font-20">
                        {{ banner.origin }}
                    </div>
                    <div class="text-nowrap">
                        {{ $t('departingHour') }}:
                    </div>
                    <b class="text-blue w-500">
                        {{ banner.departureDateTime ? $moment(banner.departureDateTime).format('HH:mm') : ' - ' }}
                    </b>
                </div>

                <div class="flex-1 flex-fill text-center px-2">
                    <p class="m-0 small">
                        {{ banner.departureDateTime ? $moment(banner.departureDateTime).format('dddd jD jMMMM') : '' }}
                    </p>
                    <div class="line-circle my-2" />
                    <img :src="banner.providerLogoPath" alt="" width="70">
                </div>

                <div>
                    <div class="w-500 font-20">
                        {{ banner.destination }}
                    </div>
                    <div class="text-nowrap">
                        {{ $t('arrivingHour') }}:
                    </div>
                    <b class="text-blue w-500">
                        {{ banner.arrivalDateTime ? $moment(banner.arrivalDateTime).format('HH:mm') : ' - ' }}
                    </b>
                </div>
            </div>

            <span v-if="!$device.mobile" class="vr" />

            <hr v-if="$device.mobile" class="my-2 flex-fill">

            <div class="text-center" :class="$device.mobile ? 'flex flex-fill flex-justify-space-between flex-align-center' : 'flex-shrink'">
                <span class="text-danger font-22 w-500 promotion-banner__off">{{ banner.oldPrice | addCommas }}</span>
                <br v-if="!$device.mobile">
                <strong class="text-success font-22 text-nowrap promotion-banner__price">{{ banner.newPrice | addCommas }} <small class="w-normal">تومان</small></strong>
                <a class="btn btn-info w-500 py-1 px-2 px-3-sm font-14 mt-1" :href="banner.link" target="_blank">
                    {{ $t('purchaseTicket') }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import CountDown from '~/components/common/count-down/count-down';
import PromotionBanner from './promotion-banner';

export default {

    components: {
        CountDown,
    },

    extends: PromotionBanner,
};
</script>

<style lang="scss" scoped>
// stylelint-disable
</style>
